import { message, Modal } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { userExitLogin } from '@/common/http/user';
import { isSuccessCode } from '@/common/utils/response';
import { setUser } from '@/common/store/person/slice';
import { TRouter } from '@/common/basis/types/trouter';
import { removeCookieUserToken } from '@/common/utils/cookies';

function App(props: { isOpen: boolean; setIsOpen: (isOpen: boolean) => void }) {
  const isOpen = props.isOpen;
  const setIsOpen = props.setIsOpen;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isExitLoading, setIsExitLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage({ top: 60 });
  const { t } = useTranslation();

  // 退出跳转至Home页面
  const navigateHome = async () => {
    if (isExitLoading) {
      return;
    }
    setIsExitLoading(true);
    try {
      const resp = await userExitLogin();

      if (!isSuccessCode(resp?.code)) {
        messageApi.destroy();
        messageApi.warning(resp?.msg);
      }
    } catch (err) {
      // TODO
    }
    removeCookieUserToken();
    dispatch(setUser(undefined)); // 清空store中的用户信息
    navigate(TRouter.ROUTE_LOGIN, { replace: true });
    setIsExitLoading(false);
  };

  return (
    <>
      <Modal
        cancelText={t('cancel')}
        centered
        okButtonProps={{ loading: isExitLoading }}
        okText={t('logout')}
        onCancel={() => setIsOpen(false)}
        onOk={async () => await navigateHome()}
        open={isOpen}
        title={t('logout')}
        width={400}
      >
        <div className='mx-5 py-5'>
          <span>{t('exitLogin')}</span>
        </div>
      </Modal>
      {contextHolder}
    </>
  );
}

export default App;
